import React from "react";

import TripsListContent from "../components/trips/trips-list";

const Trips = () => {
  return <TripsListContent />;
};

export default Trips;
